module.exports = __webpack_public_path__ + "img/add.7320c919-7cee0a0a.3bc11074.svg";